'use client'
import { FormattedMessage } from "react-intl";
import CustomNumberFormat from "@/app/components/common/CustomNumberFormat";
import NumberInput from "@/app/components/inputs/NumberInput";
import Link from "next/link";
import CartProcessStep from "@/app/constants/CartProcessStep";
import { addToCart, deleteCartItem } from "@/app/services/CartService";
import { useDispatch } from "react-redux";
import { updateCart } from "@/app/slices/CartSlice";
import { isEmptyObject } from "@/app/utils/Validations";
import styles from '@/app/styles/components/pages/cart/cart-content.module.scss'
import { useRouter } from "next/navigation";
import {getCDNImage} from "@/app/utils/ImageUtil";

const CartContent = ({ products, cart, changeStep, onRemoveItem }) => {

    const router = useRouter();
    const dispatch = useDispatch();
    const handleQuantityUpdate = (id, quantity) => {
        addToCart({
            [id]: quantity
        }).then(response => {
            dispatch(updateCart({ data: response, uuid: 'content' }))
        })
    }
    const handleRemoveItem = async (id) => {
        const response = await deleteCartItem(id)
        dispatch(updateCart({ data: response, uuid: 'content delete' }))
        onRemoveItem(id)
        router.push('/korpa')
    }
    const imageStyle = (imageUrl) => ({
        backgroundImage: `url(${imageUrl ? getCDNImage(imageUrl) : '/pzn-transparent.png'})`,
        backgroundSize: 'cover',
        backgroundRepeat: 'no-repeat',
        backgroundPositionX: 'center',
        backgroundPositionY: 'center'
    });
    const getTotal = (products) => {
        return products.reduce((total, product) => {
            const productPrice = product?.price || 0;
            const productQuantity = cart[product.id] || 0;
            return total + (productPrice * productQuantity);
        }, 0);
    }

    return <>
        <h1 className={styles.title}><FormattedMessage id={'components.pages.cart.cartContent.cartContent'} /></h1>
        {isEmptyObject(cart) ? <FormattedMessage id={'components.pages.cart.cartContent.emptyCart'} /> : !products.length ? <FormattedMessage id={'components.pages.cart.cartContent.loading'} /> : (
            <div className={styles.cartContentContainer}>
                {products.map((product, idx) =>
                (<div key={'product-' + idx} className={styles.item}>
                    <div className={styles.dataItem}>
                        <div style={imageStyle(product.images[0]?.src)} className={styles.image} />
                        <Link href={'/proizvod/' + product.slug}>
                            <span className={styles.name}>{product.name}</span>
                        </Link>
                    </div>
                    <div className={styles.dataItemCenter}>
                        <NumberInput defaultValue={cart[product.id]}
                            onClick={(quantity) => handleQuantityUpdate(product.id, quantity)} />
                    </div>
                    <div className={styles.dataItemCenter}>
                        <span className={styles.price}>
                            <CustomNumberFormat value={parseFloat(product?.price * cart[product.id]).toFixed(2)} />
                        </span>
                    </div>
                    <div className={styles.dataItemCenter}>
                        <button type='button' className={styles.removeButton} onClick={() => handleRemoveItem(product.id)}>
                            <FormattedMessage id={'components.pages.cart.cartContent.remove'} />
                        </button>
                    </div>
                </div>)
                )}
            </div>
        )}
        <div className={styles.totalContainer}>
            <div className={styles.totalContainerItem}>
                <div className={styles.totalContainerLeft}>
                    <FormattedMessage id={'components.pages.cart.cartContent.total'} />
                </div>
                <div className={styles.totalContainerRight}>
                    <CustomNumberFormat value={parseFloat(getTotal(products)).toFixed(2)} />
                </div>
            </div>
        </div>
        <div className={styles.controls}>
            <Link href={'/'}><FormattedMessage id={'components.pages.cart.cartContent.backToShop'} /></Link>
            <button onClick={() => changeStep(CartProcessStep.DELIVERY)}><FormattedMessage
                id={'components.pages.cart.cartContent.continueToDeliveryAddress'} /></button>
        </div>
    </>
}

export default CartContent